import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import Statement from "./Componets/Statement";
import T_Format from "./Componets/T_Format";
import Closing from "./Componets/Closing";
import Cookies from "js-cookie";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import FASFilterBox from "../../../../components/FilterBox/FASFilter/FASFilter";
import { AcGroupList } from "../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import { useTheme } from "../../../../Themecontext/Themecontext";
import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import Calendar from "react-calendar";
import FASCalender from "../../../../components/Calendar/FASCalender";

export const BalanceSheet = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("STATEMENT");

  const [showFilter, setShowFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { AcGroupListdata } = useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const FinancialYear = Cookies.get("FinancialYear");
  const { theme } = useTheme();
  const isdark = theme;

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const [filters, setFilters] = useState({
    accountGroup: [],
  });

  const [search, setSearch] = useState({
    accountGroup: "",
  });

  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");
  useEffect(() => {
    dispatch(AcGroupList({ Firm, Year: YearId }));
  }, [dispatch, Firm, YearId]);

  const accountGroupList =
    AcGroupListdata?.BalShetGrp?.map((item) => ({
      label: item?.GroupMstName,
      value: item?.GroupMstID,
    })) || [];

  const actionButtons = ["STATEMENT", "T-FORMAT", "CLOSING"];
  const toggleItem = (item) => {
    const newSelected =
      filters.accountGroup[0] === item.value ? [] : [item.value];

    const selectedIds = newSelected.join(",");

    setFilters({
      ...filters,
      accountGroup: newSelected,
    });
  };

  const selectAll = () => {
    const allIds = accountGroupList.map((i) => i.value);

    setFilters((prev) => {
      const newSelected =
        prev.accountGroup.length === accountGroupList.length ? [] : allIds;

      const selectedIds = newSelected.join(",");

      return {
        ...prev,
        accountGroup: newSelected,
      };
    });
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const selectedIds = filters.accountGroup.join(",");

  const renderPage = () => {
    const commonProps = {
      selectedIds,
      Fromdate: safeFormat(startDate),
      ToDate: safeFormat(endDate),
    };

    switch (activeTab) {
      case "STATEMENT":
        return <Statement {...commonProps} />;

      case "T-FORMAT":
        return <T_Format {...commonProps} />;

      case "CLOSING":
        return <Closing {...commonProps} />;

      default:
        return <Statement {...commonProps} />;
    }
  };

  return (
    <div
      style={{
        padding: "16px",
        background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
        .hover-scale-btn {
          transition: transform 0.2s ease-in-out;
        }
        .hover-scale-btn:hover {
          transform: scale(1.02);
        }
      `}</style>
      {/* MOBILE BUTTON */}
      <div
        className="d-lg-none"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "12px",
        }}
      >
        <Button
          onClick={handleShow}
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour8,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour3,
            border: "none",
            borderRadius: "10px",
            padding: "8px 12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.18)",
          }}
        >
          <FiMenu size={22} />
        </Button>
      </div>

      {/* OFFCANVAS */}
      <Offcanvas
        show={showFilter}
        onHide={handleClose}
        placement="start"
        style={{
          background: isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
            style={{ color: isdark === "light" ? "#000" : "#fff" }}
          >
            Filters
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                padding: "13px 20px",
                borderRadius: "10px 10px 0px 0px",
              }}
            >
              <h3
                style={{
                  fontWeight: "700",
                  fontSize: "18px",
                  margin: 0,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                {" "}
                Date Range
              </h3>
            </div>
            <div
              style={{
                border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                padding: "15px",
                marginBottom: "15px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <div
                onClick={() => setShowDatePicker(true)}
                style={{
                  marginTop: "8px",
                  padding: "10px",
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                  borderRadius: "8px",
                  cursor: "pointer",
                  color: isdark === "light" ? "#000" : iscolourDark?.Colour11,
                  textAlign: "center",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </div>
          <FASFilterBox
            title="Account Group"
            items={accountGroupList}
            search={search.accountGroup}
            setSearch={(val) => handleSearch("accountGroup", val)}
            selectedItems={filters.accountGroup}
            toggleItem={(item) => toggleItem(item)}
            selectAll={selectAll}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Row className="g-4 align-items-start">
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div>
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour10,
                padding: "13px 20px",
                borderRadius: "10px 10px 0px 0px",
              }}
            >
              <h3
                style={{
                  fontWeight: "700",
                  fontSize: "18px",
                  margin: 0,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  alignItems: "center",
                  display: "flex",
                }}
              >
                {" "}
                Date Range
              </h3>
            </div>
            <div
              style={{
                border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                padding: "15px",
                marginBottom: "15px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                borderRadius: "0px 0px 10px 10px",
              }}
            >
              <div
                onClick={() => setShowDatePicker(true)}
                style={{
                  marginTop: "8px",
                  padding: "10px",
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                  borderRadius: "8px",
                  cursor: "pointer",
                  color: isdark === "light" ? "#000" : iscolourDark?.Colour11,
                  textAlign: "center",
                }}
              >
                {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                  : "Select Date Range"}
              </div>
            </div>
          </div>

          <FASFilterBox
            title="Account Group"
            items={accountGroupList}
            search={search.accountGroup}
            setSearch={(val) => handleSearch("accountGroup", val)}
            selectedItems={filters.accountGroup}
            toggleItem={(item) => toggleItem(item)}
            selectAll={selectAll}
          />
        </Col>

        <Col xl={9} lg={8} md={12}>
          <Row className="g-3 mb-3">
            {actionButtons.map((btn, index) => {
              const isActive = activeTab === btn;

              return (
                <Col xs={12} md={4} sm={4} lg={4} key={index}>
                  <button
                    className="hover-scale-btn"
                    onClick={() => setActiveTab(btn)}
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${
                        isActive
                          ? isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10
                          : isdark === "light"
                            ? iscolour?.Colour4
                            : iscolourDark?.Colour10
                      }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                      fontSize: "14px",
                    }}
                  >
                    {btn}
                  </button>
                </Col>
              );
            })}
          </Row>

          {renderPage()}
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
